import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

import { useTheme } from "@mui/styles";
import { UploadFile } from "@mui/icons-material";
import { updateFBA } from "../../reducers/fbaSlice";
import uuid from "react-uuid";
import { useSnackbar } from "notistack";
import { selectUser } from "../../reducers/userSlice";
import { addProject, selectProjects } from "../../reducers/projectSlice";
import { useSocket } from "../../context/useSocket";


export const ImportFBA = ({ setImportFBAVisible, darkMode }) => {
  
  const theme = useTheme();

  const [fbaLink, setFBALink] = useState("");  
  const user = useSelector(selectUser);
  const projects = useSelector(selectProjects);


  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const { socket } = useSocket();

  return (
    <Dialog 
      open={true} 
      onClose={() => {}}
      fullWidth={true}
      maxWidth="md"
      PaperProps={{
        style: {
          backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
        },
      }}
      elevation={0}
    >
      <DialogTitle id="form-dialog-title">Import FBA</DialogTitle>
      <DialogContent>
        <Typography>Import FBA from a link</Typography>
        <TextField
          autoFocus
          margin="normal"
          id="link"
          label="FBA Link"
          placeholder="Paste FBA link"
          type="text"
          fullWidth
          value={fbaLink || ""}
          variant="outlined"
          onChange={e => setFBALink(e.target.value)}
        />

        <div style={{marginTop: 20}}>
          <Typography>Import FBA from a file</Typography>
          <Button
            component="label"
            color={darkMode ? "inherit" : "primary"}
            style={{color: darkMode ? '#000' : '#fff', marginTop: 10}}
            variant="contained"  
            startIcon={<UploadFile />}
          >
            Upload FBA
            <input
              type="file"
              accept=".json"
              hidden
              onChange={e => handleImportFBAFile(e)}
            />
          </Button>
        </div>
        
      </DialogContent>
      <DialogActions style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button onClick={() => setImportFBAVisible(false)} color={darkMode ? "inherit" : "primary"} style={{marginRight: 10}}>
          Cancel
        </Button>
        <Button onClick={() => handleFBAImportClick(user?.value?.email)} color={darkMode ? "inherit" : "primary"}
          style={{color: darkMode ? '#000' : '#fff'}} variant="contained" disabled={fbaLink?.length === 0}
        >
          Import
        </Button>
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  function handleFBAImportClick(email) {
    try {
      if (fbaLink?.length > 0) { // if link is provided
        handleImportFBALink(fbaLink, email);
        setImportFBAVisible(false);
      };
    } catch (error) {
      console.log(error);
      return;
    };
  };

  async function handleImportFBALink(location, email) { // import FBA from a link
    try {
      console.log('Importing FBA from a link...');
  
      if (!location.length > 0) {
        return false;
      };

      const res = await fetch(location, {cache: "no-store"});
      const fb = await res.json();

      if (!fb) return;

      const fbaId = uuid();

      const newFba = {...fb, id: fbaId, public: false, projectId: projects?.currentProjectId, createdBy: email};

      dispatch(updateFBA({fba: newFba, fbaId: newFba.id}));
      
      socket.send(JSON.stringify({
        messageType: 'saveFBA', 
        fba: newFba, 
        fileName: newFba?.id, 
        userEmail: email
      }));

      // update project with new FBA id
      const currentProject = {...projects?.byId?.[newFba?.projectId]};

      if (!currentProject.fbaIds || !currentProject.fbaIds.includes(newFba.id)) {
        if (!currentProject.fbaIds) currentProject.fbaIds = [];
        currentProject.fbaIds = [...currentProject.fbaIds, newFba.id];
        dispatch(addProject({ project: currentProject, lists: [], email: email }));
      };

    } catch (error) {
      console.log('Could not import FBA!');
      console.log(error);
    };
  };

  
  function handleImportFBAFile(e) { // import FBA from a .json file
    
    try {
      console.log('Importing FBA from a file...');
      let files = e.target.files;
  
      if (!files.length > 0) {
        return false;
      };
      
      let reader = new FileReader();
      
      reader.readAsText(files[0]);
      
      reader.onload = (event) => {
        let fba = JSON.parse(event.target.result);
        if (!fba) return false;
        fba = {...fba, id: uuid(), lastModified: new Date()?.toDateString()}; // change FBA id to prevent overlap

        dispatch(updateFBA({ fbaId: fba.id, fba: fba }));
        setImportFBAVisible(false);
        enqueueSnackbar('FBA file imported successfully', { variant: 'success' });
      };
    } catch (error) {
      console.log('Coudld not import FBA!');
      console.log(error);
    };
  };
};